import { SampleStatus } from "./../../service/src/modules/sample/enums/sample-status.enum";

export const SAMPLE_STATUS_DICT: Record<
  SampleStatus,
  {
    description: string;
    tooltip: string;
    color: string;
    order?: number;
    icon?: string;
  }
> = {
  [SampleStatus.FINISHED]: {
    description: "已完成",
    tooltip: "样本已完成并提交，如需修改请联系管理员",
    color: "#2b6f27",
    order: 1,
    icon: "fa-clipboard-check",
  },
  [SampleStatus.NOT_STARTED]: {
    description: "未开始",
    tooltip: "还未开始调查",
    color: "#f57b07",
    order: 5,
    icon: "fa-satellite-dish",
  },
  [SampleStatus.NOT_FIND]: {
    description: "无效",
    tooltip: "样本无法找到且样本已提交，如需修改请联系管理员",
    color: "#25332f",
    order: 4,
    icon: "fa-cat",
  },
  [SampleStatus.REJECTED]: {
    description: "拒访",
    color: "#E74C3C",
    tooltip: "样本已拒访并且样本已提交，如需修改请联系管理员",
    order: 3,
    icon: "fa-comment-slash",
  },
  [SampleStatus.STARTED]: {
    description: "进行中",
    tooltip: "调查进行中",
    color: "#3498DB",
    order: 2,
    icon: "fa-book-reader",
  },
};
